<template>
  <div class="expandable-options">
    <div class="expandable-options-title">
      {{ title }}
    </div>
    <template v-if="structure.keys && structure.keys.length > 1">
      <input-group v-for="(item, index) in modelValue" v-bind:key="index" inline :keys="structure.keys" :placeholder="structure.placeholder" :modelValue="modelValue[index]" @modelEvent="newValue => changeInput(index, newValue)" :label="label + ' ' + index" deletable @delete-button-clicked="() => removeInput(index)" />
    </template>
    <template v-else>
      <input-group v-for="(item, index) in modelValue" v-bind:key="index" inline :placeholder="structure.placeholder" :modelValue="modelValue[index]" @modelEvent="newValue => changeInput(index, newValue)" :label="label + ' ' + index" deletable @delete-button-clicked="() => removeInput(index)" />
    </template>
    <div class="add-button" @click="addInput">
      ADD ANOTHER
    </div>
  </div>
</template>

<script>
import InputGroup from "@/views/PushNotification/UIComponents/InputGroup";

export default {
  name: "ExpandableOptions",
  components: {
    InputGroup
  },
  model: {
    prop: 'modelValue',
    event: 'modelEvent'
  },
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    structure: {
      type: Object,
      default: () => {}
    },
    title: String,
    label: String
  },
  methods: {
    addInput() {
      let newItem;
      if(this.structure.keys && this.structure.keys.length > 1) {
        newItem = {};
        this.structure.keys.forEach(key => newItem[key] = "")
      } else {
        newItem = "";
      }
      this.$emit('modelEvent', [...this.modelValue, newItem])
      setTimeout(() => console.log(this.modelValue), 500)
    },
    removeInput(index) {
      const newValue = [...this.modelValue]
      newValue.splice(index, 1)
      this.$emit('modelEvent', newValue)
      setTimeout(() => console.log(this.modelValue), 500)
    },
    changeInput(index,value) {
      const newValue = [...this.modelValue]
      newValue[index] = value

      this.$emit('modelEvent', newValue)
      setTimeout(() => console.log(this.modelValue), 500)
    }
  }
}
</script>

<style scoped>
.expandable-options-title {
  color: #BB86FC;
  font-size: 16px;

}


.add-button {
  cursor: pointer;
  background-color: #BB86FC;
  color: white;
  padding: 10px;
  margin: 10px 0;
  display: inline-block;
}
</style>